/* eslint-disable */
// @ts-nocheck
import React, { useState, useEffect, useRef, useContext } from 'react';
import Tesseract from 'tesseract.js';
import {
    companionList, buildList, mainstatList, substatList, levelList, coreTypeList, stellactrumList,
    memoryList
} from './constants';
import { defaultTeams, InputCoreCard } from './InputCoreCard.tsx';
import ChangeLog from './ChangeLog.tsx';
import './Rater.css';
import './Viewer.css';
import { idText } from 'typescript';

const Rater = () => {
    const [companion, setCompanion] = useState([]);
    const allCompanionSelected = companion.length === companionList.length;
    const [build, setBuild] = useState([]);
    const [core, setCore] = useState({
        stellactrum: "",
        mainstat: "",
        level: 0,
        type: "",
        substat1: { attribute: "", value: 0, rv: [], rcount: 0, ssRating: [] },
        substat2: { attribute: "", value: 0, rv: [], rcount: 0, ssRating: [] },
        substat3: { attribute: "", value: 0, rv: [], rcount: 0, ssRating: [] },
        substat4: { attribute: "", value: 0, rv: [], rcount: 0, ssRating: [] },
        totalRV: [],
        rvRating: [],
        msRating: [],
        equip: "",
    });
    const [error, setError] = useState(""); 
    //const [coreList, setCoreList] = useState([]);
    const coreListContext = useContext(InputCoreCard);
    if (!coreListContext) {
        throw new Error("useContext must be used inside a CoreCardProvider");
    }
    const { coreList, setCoreList } = coreListContext;
    const [complete, setComplete] = useState("false");
    const [readyForDisplay, setReadyForDisplay] = useState(false);
    const [openDropdowns, setOpenDropdowns] = useState({});
    const [enabledStrictRating, setEnabledStrictRating] = useState(false);
    const [enabledFlatStat, setEnabledFlatStat] = useState(false);
    const [enabledComment, setEnabledComment] = useState(true);
    const [openAnalysis, setOpenAnalysis] = useState({
        cIndex: -1,
        bIndex: -1
    });
    //const [tagCIndex, setTagCIndex] = useState([]);
    const tagCContext = useContext(InputCoreCard);
    if (!tagCContext) {
        throw new Error("useContext must be used inside a CoreCardProvider");
    }
    const { tagCIndex, setTagCIndex } = tagCContext;
    //const [tagBIndex, setTagBIndex] = useState([]);
    const tagBContext = useContext(InputCoreCard);
    if (!tagBContext) {
        throw new Error("useContext must be used inside a CoreCardProvider");
    }
    const { tagBIndex, setTagBIndex } = tagBContext;
    const teamContext = useContext(InputCoreCard);
    if (!teamContext) {
        throw new Error("useContext must be used inside a CoreCardProvider");
    }
    const { team, setTeam } = teamContext;
    const [openLog, setOpenLog] = useState(false);
    const [openInstruction, setOpenInstruction] = useState(false);
    const [sortedRV, setSortedRV] = useState([]);
    const [isScanning, setIsScanning] = useState(false);
    const dropdownRefs = useRef({});
    const buttonRefs = useRef({});
    const fileInputRef = useRef();
    const imageInputRef = useRef();

    const toggleDropdown = (dropdownId) => {
        setOpenDropdowns((prevState) => {
            const newState = { ...prevState, [dropdownId]: !prevState[dropdownId] };
            return newState;
        });
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
          setOpenDropdowns((prevState) => {
            const newState = { ...prevState };
            Object.keys(newState).forEach((id) => {
              const buttonRef = buttonRefs.current[id];
              const dropdownRef = dropdownRefs.current[id];
              if (
                (!buttonRef || !buttonRef.contains(event.target)) &&
                (!dropdownRef || !dropdownRef.contains(event.target))
              ) {
                newState[id] = false;
              }
            });
            return newState;
          });
        };
      
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const groupByCharacter = (list: any[]): Record<string, any[]> => {
        return list.reduce((acc, companion) => {
            acc[companion.character] = acc[companion.character] || [];
            acc[companion.character].push(companion);
            return acc;
        }, {});
    };

    const reverseCompletion = () => {
        setComplete("false");
        setReadyForDisplay(false);
        setOpenAnalysis({ cIndex: -1, bIndex: -1 });
    } 

    const selectCompanion = (selectedCompanion) => {
        if (selectedCompanion.companion === "all") {
            setCompanion(allCompanionSelected ? [] : companionList);
        }
        else {
            setCompanion((prevSelected) =>
            prevSelected.some((selected) => selected.companion === selectedCompanion.companion)
              ? prevSelected.filter((selected) => selected.companion !== selectedCompanion.companion)
              : [...prevSelected, selectedCompanion]
            );
        }
        reverseCompletion();
    }

    const selectBuild = (selectedBuild) => {
        setBuild((prevSelected) =>
            prevSelected.some((selected) => selected === selectedBuild)
              ? prevSelected.filter((selected) => selected !== selectedBuild)
              : [...prevSelected, selectedBuild]
        );
        reverseCompletion();
    }

    const selectStellactrum = (stellactrum) => {
        setCore({...core, stellactrum: stellactrum});
        setOpenDropdowns((prevState) => ({
            ...prevState,
            ["stellactrumDD"]: false,
        }));
        reverseCompletion();
    }
	
    const selectMainstat = (mainstat) => {
        setCore({...core, mainstat: mainstat});
        setOpenDropdowns((prevState) => ({
            ...prevState,
            ["mainstatDD"]: false,
        }));
        reverseCompletion();
    }

    const selectCoreLevel = (level) => {
        setCore({...core, level: level});
        setOpenDropdowns((prevState) => ({
            ...prevState,
            ["levelDD"]: false,
        }));
        reverseCompletion();
    }

    const selectCoreType = (type) => {
        const mainstat = type === "Alpha" ? "HP" : type === "Gamma" ? "ATK" : "";
        setCore({...core, type: type, mainstat: mainstat});
        setOpenDropdowns((prevState) => ({
            ...prevState,
            ["typeDD"]: false,
        }));
        reverseCompletion();
    }
    

    const selectSubstat1 = (substat) => {
        const previousSubstat2 = core.substat2;
        const previousSubstat3 = core.substat3;
        const previousSubstat4 = core.substat4;
        if (substat === previousSubstat2.attribute) {
            setCore({ ...core, substat1: previousSubstat2, substat2: { attribute: "", value: 0 }});
        }
        else if (substat === previousSubstat3.attribute) {
            setCore({ ...core, substat1: previousSubstat3, substat3: { attribute: "", value: 0 }});
        }
        else if (substat === previousSubstat4.attribute) {
            setCore({ ...core, substat1: previousSubstat4, substat4: { attribute: "", value: 0 }});
        }
        else {
            setCore({ ...core, substat1: { ...core.substat1, attribute: substat } });
        }
        setOpenDropdowns((prevState) => ({
            ...prevState,
            ["substat1DD"]: false,
        }));
        reverseCompletion();
    }
    
    const selectSubstat1Value = (event) => {
        const value = event.target.value === "" ? "" : Number(event.target.value);
        setCore({ ...core, substat1: { ...core.substat1, value: value } });
        reverseCompletion();
    }

    const selectSubstat2 = (substat) => {
        const previousSubstat1 = core.substat1;
        const previousSubstat3 = core.substat3;
        const previousSubstat4 = core.substat4;
        if (substat === previousSubstat1.attribute) {
            setCore({ ...core, substat2: previousSubstat1, substat1: { attribute: "", value: 0 }});
        }
        else if (substat === previousSubstat3.attribute) {
            setCore({ ...core, substat2: previousSubstat3, substat3: { attribute: "", value: 0 }});
        }
        else if (substat === previousSubstat4.attribute) {
            setCore({ ...core, substat2: previousSubstat4, substat4: { attribute: "", value: 0 }});
        }
        else {
            setCore({ ...core, substat2: { ...core.substat2, attribute: substat } });
        }
        setOpenDropdowns((prevState) => ({
            ...prevState,
            ["substat2DD"]: false,
        }));
        reverseCompletion();
    }
    
    const selectSubstat2Value = (event) => {
        const value = event.target.value === "" ? "" : Number(event.target.value);
        setCore({ ...core, substat2: { ...core.substat2, value: value } });
        reverseCompletion();
    }

    const selectSubstat3 = (substat) => {
        const previousSubstat1 = core.substat1;
        const previousSubstat2 = core.substat2;
        const previousSubstat4 = core.substat4;
        if (substat === "None") {
            setCore({ ...core, substat3: { attribute: substat, value: 0 } });
        }
        else {
            if (substat === previousSubstat1.attribute) {
                setCore({ ...core, substat3: previousSubstat1, substat1: { attribute: "", value: 0 }});
            }
            else if (substat === previousSubstat2.attribute) {
                setCore({ ...core, substat3: previousSubstat2, substat2: { attribute: "", value: 0 }});
            }
            else if (substat === previousSubstat4.attribute) {
                setCore({ ...core, substat3: previousSubstat4, substat4: { attribute: "", value: 0 }});
            }
            else {
                setCore({ ...core, substat3: { ...core.substat3, attribute: substat } });
            }
        }
        setOpenDropdowns((prevState) => ({
            ...prevState,
            ["substat3DD"]: false,
        }));
        reverseCompletion();
    }
    
    const selectSubstat3Value = (event) => {
        const value = event.target.value === "" ? "" : Number(event.target.value);
        setCore({ ...core, substat3: { ...core.substat3, value: value } });
        reverseCompletion();
    }

    const selectSubstat4 = (substat) => {
        const previousSubstat1 = core.substat1;
        const previousSubstat2 = core.substat2;
        const previousSubstat3 = core.substat3;
        if (substat === "None") {
            setCore({ ...core, substat4: { attribute: substat, value: 0 } });
        }
        else {
            if (substat === previousSubstat1.attribute) {
                setCore({ ...core, substat4: previousSubstat1, substat1: { attribute: "", value: 0 }});
            }
            else if (substat === previousSubstat2.attribute) {
                setCore({ ...core, substat4: previousSubstat2, substat2: { attribute: "", value: 0 }});
            }
            else if (substat === previousSubstat3.attribute) {
                setCore({ ...core, substat4: previousSubstat3, substat3: { attribute: "", value: 0 }});
            }
            else {
                setCore({ ...core, substat4: { ...core.substat4, attribute: substat } });
            }
        }
        setOpenDropdowns((prevState) => ({
            ...prevState,
            ["substat4DD"]: false,
        }));
        reverseCompletion();
    }
    
    const selectSubstat4Value = (event) => {
        const value = event.target.value === "" ? "" : Number(event.target.value);
        setCore({ ...core, substat4: { ...core.substat4, value: value } });
        reverseCompletion();
    }

    const selectEnabledStrictRating = () => {
        setEnabledStrictRating(!enabledStrictRating);
        reverseCompletion();
    }

    const selectEnabledFlatStat = () => {
        setEnabledFlatStat(!enabledFlatStat);
        reverseCompletion();
    }

    const selectEnabledComment = () => {
        setEnabledComment(!enabledComment);
    }

    const assessMainstat = (mainstat, selectedCompanion, selectedBuild) => {
        const [msRating, comment] =
            (mainstat === "ATK" || mainstat === "HP") ? ["A", ""]
            : ((mainstat === "Crit Rate" || mainstat === "Crit DMG") && (selectedBuild === "Crit Build" || selectedBuild === "Mix Build")) ? ["S", "crucial main stat for Crit Build"]
            : ((mainstat === "DMG Boost to Weakened") && (selectedBuild === "DMG to Weakened Build" || selectedBuild === "Mix Build")) ? ["S", "crucial main stat for DMG to Weakened Build"]
            : ((mainstat === "Crit Rate" || mainstat === "Crit DMG") && (selectedBuild === "DMG to Weakened Build")) ? ["B", "bad main stat for DMG to Weakened Build. Try rating this protocore with Crit Build"]
            : ((mainstat === "DMG Boost to Weakened") && (selectedBuild === "Crit Build")) ? ["B", "bad main stat for Crit Build. Try rating this protocore with DMG to Weakened Build."]
            : (mainstat === "Oath Recovery Boost") ? ["S", "crucial main stat for faster Ardent Oath regeneration, especially when Solar Pair is R0,"]
            : (mainstat === "Expedited Energy Boost" && selectedCompanion.companion === "Lemurian Sea God") ? ["B", "main stat that cannot be effectively used on Lemurian Sea God since he already has energy refund in his kit"]
            : (mainstat === "Expedited Energy Boost" && selectedCompanion.companion !== "Lemurian Sea God") ? ["S", "good main stat for faster skill point regeneration"]
            : (mainstat === "Oath's Strength" && selectedCompanion.companion === "Ultimate Weapon X-02") ? ["S", "good main stat for Ultimate Weapon X-02 as a large part of the total damage comes from Ardent Oath"]
            : (mainstat === "Oath's Strength" && selectedCompanion.companion !== "Ultimate Weapon X-02") ? ["S", "good main stat for more Oath damage"]
            : (mainstat === "DEF Bonus" && core.type === "Beta" && (selectedCompanion.companion === "Farspace Colonel" || selectedCompanion.companion === "Lemurian Sea God")) ? ["S", `good main stat for ${selectedCompanion.companion}, especially if Solar Pair is high ranked,`]
            : (mainstat === "DEF Bonus" && core.type !== "Beta" && core.type !== "" && (selectedCompanion.companion === "Farspace Colonel" || selectedCompanion.companion === "Lemurian Sea God")) ? ["B", `bad main stat${core.level < 15 ? ", do not level this piece" : ""}`]
            : (mainstat === "DEF Bonus" && core.type === "" && (selectedCompanion.companion === "Farspace Colonel" || selectedCompanion.companion === "Lemurian Sea God")) ? ["S", `If this is a Beta (cube) protocore, it has good main stat for ${selectedCompanion.companion}, especially if Solar Pair is high ranked. If this is not a Beta (cube) protocore, the main stat is bad.`]
            : ["B", `bad main stat${core.level < 15 ? ", do not level this piece" : ""}`];
        return [msRating, comment];
    }

    const assessSubstat = (substat, selectedCompanion, selectedBuild) => {
        if ((selectedCompanion.scaling === "ATK" && substat.attribute === "ATK Bonus") 
            || (selectedCompanion.scaling === "DEF" && substat.attribute === "DEF Bonus") 
            || (selectedCompanion.scaling === "HP" && substat.attribute === "HP Bonus") 
            || ((selectedBuild === "Crit Build" || selectedBuild === "Mix Build") && (substat.attribute === "Crit Rate" || substat.attribute === "Crit DMG")) 
            || ((selectedBuild === "DMG to Weakened Build" || selectedBuild === "Mix Build") && (substat.attribute === "DMG Boost to Weakened"))
            || (selectedCompanion.companion === "Ultimate Weapon X-02" && substat.attribute === "Oath's Strength")
            || (enabledFlatStat && selectedCompanion.scaling === "ATK" && substat.attribute === "ATK")
            || (enabledFlatStat && selectedCompanion.scaling === "DEF" && substat.attribute === "DEF")
            || (enabledFlatStat && selectedCompanion.scaling === "HP" && substat.attribute === "HP")) {
            return "S";
        }
        else if ((selectedCompanion.scaling === "DEF" && substat.attribute === "ATK Bonus") 
            || (selectedCompanion.scaling === "HP" && substat.attribute === "ATK Bonus") 
            || (!enabledStrictRating && selectedBuild === "Crit Build" && substat.attribute === "DMG Boost to Weakened") 
            || (!enabledStrictRating && selectedBuild === "DMG to Weakened Build" && substat.attribute === "Crit Rate")
            || (!enabledFlatStat && selectedCompanion.scaling === "ATK" && substat.attribute === "ATK") 
            || (!enabledFlatStat && selectedCompanion.scaling === "DEF" && substat.attribute === "DEF") 
            || (!enabledFlatStat && selectedCompanion.scaling === "HP" && substat.attribute === "HP") 
            || (selectedCompanion.companion !== "Ultimate Weapon X-02" && substat.attribute === "Oath's Strength")) {
            return "A";
        }
        else if (substat.attribute === "None") {
            return "none";
        }
        else {
            return "B";
        }
    }

    const validateSubstat = (substat) => {
        const attribute = substatList.find(
            (option) => option.attribute === substat.attribute
        );
        if (attribute) {
            if (substat.value < attribute.minimum || substat.value > attribute.initial + (attribute.increment * ((core.level / 3) + 2))) {
                return ["value", 0];
            }
            else if (substat.attribute !== "None") {
                const removeMaxInitial = Number((substat.value - attribute.initial).toFixed(2));
                const moreThanMaxInitial = removeMaxInitial >= 0 ? 1 : 0;
                const numberOfRolls = Math.floor(removeMaxInitial*moreThanMaxInitial/attribute.increment);
                const lastRollValue = removeMaxInitial%attribute.increment;
                let totalRollCount = 1;
                if (numberOfRolls > 0) {
                    totalRollCount = totalRollCount + numberOfRolls;
                }
                if (lastRollValue > 0) {
                    totalRollCount = totalRollCount + 1;
                }
                return ["", totalRollCount];
            }
            else {
                return ["", 0];
            }
        }
        return ["attribute", 0];
    }

    const getMinRollCount = (substat) => {
        const attribute = substatList.find(
            (option) => option.attribute === substat.attribute
        );
        if (attribute) {
            if (substat.attribute !== "None") {
                const removeMinInitial = Number((substat.value - attribute.minimum).toFixed(2));
                const moreThanMinInitial = removeMinInitial >= 0 ? 1 : 0;
                const numberOfRolls = Math.floor(removeMinInitial*moreThanMinInitial/(attribute.minimum/2));
                const lastRollValue = removeMinInitial%(attribute.minimum/2);
                let totalRollCount = 1;
                if (numberOfRolls > 0) {
                    totalRollCount = totalRollCount + numberOfRolls;
                }
                if (lastRollValue > 0) {
                    totalRollCount = totalRollCount + 1;
                }
                return totalRollCount;
            }
            else {
                return 0;
            }
        }
        return 0;
    }

    const calculateRV = (substat, selectedCompanion, selectedBuild) => {
        const attribute = substatList.find(
            (option) => option.attribute === substat.attribute
        );
        const assessedSubstat = assessSubstat(substat, selectedCompanion, selectedBuild);
        if (attribute) {
            if (substat.attribute !== "None") {
                const removeMaxInitial = Number((substat.value - attribute.initial).toFixed(2));
                const moreThanMaxInitial = removeMaxInitial >= 0 ? 1 : 0;
                const numberOfRolls = Math.floor(removeMaxInitial*moreThanMaxInitial/attribute.increment);
                const lastRollValue = removeMaxInitial%attribute.increment;
                const incrementValueTotal = numberOfRolls*attribute.increment;
                const notFullInitial = moreThanMaxInitial ? 0 : substat.value/attribute.initial*100;
                const totalRV = moreThanMaxInitial*100 + (incrementValueTotal + moreThanMaxInitial*lastRollValue)/attribute.increment*100 + notFullInitial;
                if (assessedSubstat === "S") {
                    return [totalRV, assessedSubstat];
                }
                else if (assessedSubstat === "A") {
                    return [totalRV * 0.4, assessedSubstat];
                }
                else if (assessedSubstat === "none") {
                    return [0, assessedSubstat];
                }
                else {
                    return [0, assessedSubstat];
                } 
            }
            else {
                return [0, assessedSubstat];
            }
        }
        return [0, "none"];
    }

    const calculateTotalRV = async () => {
        const [error1, numberofRoll1] = validateSubstat(core.substat1) as [string, number];
        const [error2, numberofRoll2] = validateSubstat(core.substat2) as [string, number];
        const [error3, numberofRoll3] = validateSubstat(core.substat3) as [string, number];
        const [error4, numberofRoll4] = validateSubstat(core.substat4) as [string, number];
        const rollCount = numberofRoll1 + numberofRoll2 + numberofRoll3 + numberofRoll4;
        const requiredRollCount = (core.level >= 6) ? (4 + core.level / 3) - 3 
                                : (4 + core.level / 3) - 2
        const maxRollCount = 4 + core.level / 3;
        let errorFromRollCount = "";
        if (rollCount < 4) {
            const numberofMinRoll1 = getMinRollCount(core.substat1);
            const numberofMinRoll2 = getMinRollCount(core.substat2);
            const numberofMinRoll3 = getMinRollCount(core.substat3);
            const numberofMinRoll4 = getMinRollCount(core.substat4);
            const minRollCount = numberofMinRoll1 + numberofMinRoll2 + numberofMinRoll3 + numberofMinRoll4;
            if (minRollCount < 4) {
                errorFromRollCount = "value";
            }
        }
        if (error1 === "value" || error2 === "value" || error3 === "value" || error4 === "value" || errorFromRollCount === "value") {
            setError("Invalid substat values.");
        }
        else if (error1 === "attribute" || error2 === "attribute" || error3 === "attribute" || error4 === "attribute") {
            setError("Some attributes are not selected.");
        }
        else if (rollCount < requiredRollCount) {
            setError(`Number of substat rolls is ${rollCount} but must be at least ${requiredRollCount} rolls.`);
        }
        else if (rollCount > maxRollCount) {
            setError(`Number of substat rolls is ${rollCount} but should have no more than ${maxRollCount} rolls.`);
        }
        else {
            let newSubstat1RV: number[][] = [];
            let newSubstat2RV: number[][] = [];
            let newSubstat3RV: number[][] = [];
            let newSubstat4RV: number[][] = [];
            let newSSRating1: string[][] = [];
            let newSSRating2: string[][] = [];
            let newSSRating3: string[][] = [];
            let newSSRating4: string[][] = [];
            let newTotalRV: number[][] = [];
            let newRVRating: string[][] = [];
            let newMSRating: string[][] = [];
            for (let i = 0; i < companion.length; i++) {
                let substat1RVrow: number[] = [];
                let substat2RVrow: number[] = [];
                let substat3RVrow: number[] = [];
                let substat4RVrow: number[] = [];
                let ssRating1row: string[] = [];
                let ssRating2row: string[] = [];
                let ssRating3row: string[] = [];
                let ssRating4row: string[] = [];
                let totalRVrow: number[] = [];
                let rvRatingrow: string[] = [];
                let msRatingrow: string[] = [];
                for (let j = 0; j < build.length; j++) {
                    const [substat1RV, assessedSubstat1] = calculateRV(core.substat1, companion[i], build[j]) as [number, string];
                    const [substat2RV, assessedSubstat2] = calculateRV(core.substat2, companion[i], build[j]) as [number, string];
                    const [substat3RV, assessedSubstat3] = calculateRV(core.substat3, companion[i], build[j]) as [number, string];
                    const [substat4RV, assessedSubstat4] = calculateRV(core.substat4, companion[i], build[j]) as [number, string];
                    const totalRV = Math.round(substat1RV + substat2RV + substat3RV + substat4RV);
                    const rvRating = (totalRV < ((4 + core.level / 3) * 100 / 4)) ? "C"
                        : (totalRV < ((4 + core.level / 3) * 100 / 2)) ? "B"
                        : (totalRV < ((4 + core.level / 3) * 100 / 4) * 3) ? "A"
                        : "S";
                    const [msRating] = assessMainstat(core.mainstat, companion[i], build[j]);
                    substat1RVrow.push(substat1RV);
                    substat2RVrow.push(substat2RV);
                    substat3RVrow.push(substat3RV);
                    substat4RVrow.push(substat4RV);
                    ssRating1row.push(assessedSubstat1);
                    ssRating2row.push(assessedSubstat2);
                    ssRating3row.push(assessedSubstat3);
                    ssRating4row.push(assessedSubstat4);
                    totalRVrow.push(totalRV);
                    rvRatingrow.push(rvRating);
                    msRatingrow.push(msRating);
                }
                newSubstat1RV.push(substat1RVrow);
                newSubstat2RV.push(substat2RVrow);
                newSubstat3RV.push(substat3RVrow);
                newSubstat4RV.push(substat4RVrow);
                newSSRating1.push(ssRating1row);
                newSSRating2.push(ssRating2row);
                newSSRating3.push(ssRating3row);
                newSSRating4.push(ssRating4row);
                newTotalRV.push(totalRVrow);
                newRVRating.push(rvRatingrow);
                newMSRating.push(msRatingrow);
            }
            setCore({...core, totalRV: newTotalRV, rvRating: newRVRating, msRating: newMSRating, equip: "",
                substat1: { ...core.substat1, rv: newSubstat1RV, rcount: numberofRoll1, ssRating: newSSRating1 },
                substat2: { ...core.substat2, rv: newSubstat2RV, rcount: numberofRoll2, ssRating: newSSRating2 },
                substat3: { ...core.substat3, rv: newSubstat3RV, rcount: numberofRoll3, ssRating: newSSRating3 },
                substat4: { ...core.substat4, rv: newSubstat4RV, rcount: numberofRoll4, ssRating: newSSRating4 }
            });
            setError("");
            setComplete("rater");
        }
    }

    const substatDropdown = (substat, refName, displayText, hasNone, setSubstatAttribute, setSubstatValue) => {
        return (
            <div>
                <p className="memory-label">{displayText}</p>
                <div className="form-row">
                    <button ref={(el) => (buttonRefs.current[refName] = el)} className={`form-select left-select select-width-70 dropdown white-bg-color`}
                    onClick={() => toggleDropdown(refName)}>
                        <p className="dropdown-text">{substat.attribute || displayText}</p>
                        {openDropdowns[refName] ? <p className="dropdown-arrow">&#9652;</p> : <p className="dropdown-arrow">&#9662;</p>}
                    </button>
                    {openDropdowns[refName] && (
                        <div ref={(el) => (dropdownRefs.current[refName] = el)} className="dropdown-list-left select-width-70">
                            { hasNone ? substatList.map((option, index) => (
                                <div key={index} className="dropdown-item default-bg-color-hover"
                                onClick={() => setSubstatAttribute(option.attribute)}>
                                    {option.attribute}
                                </div>
                            )) :
                            substatList.filter((option) => option.attribute !== "None").map((option, index) => (
                                <div key={index} className="dropdown-item default-bg-color-hover"
                                onClick={() => setSubstatAttribute(option.attribute)}>
                                    {option.attribute}
                                </div>
                            ))}
                        </div>
                    )}
                    <input 
                        type="number" 
                        className={`form-select right-select select-width-30 ${substat.attribute === "" || substat.attribute === "None" ? "disabled-form" : ""}`}
                        value={substat.value} 
                        disabled={ hasNone ? (substat.attribute === "" || substat.attribute === "None") : substat.attribute === "" } 
                        onChange={setSubstatValue}
                    />
                </div>
            </div>
            
        );
    }

    const handleOpenAnalysis = (cIndex, bIndex) => {
        if (openAnalysis.cIndex === cIndex && openAnalysis.bIndex === bIndex) {
            setOpenAnalysis({ cIndex: -1, bIndex: -1});
        }
        else {
            setOpenAnalysis({ cIndex: cIndex, bIndex: bIndex });
        }
    }

    const handleOpenLog = () => {
        setOpenLog(!openLog);
    }

    const getSortedTotalRV = (core) => {
        const ratingOrder = { "S": 3, "A": 2, "B": 1 };
        let indexedData: { companionIndex: number; buildIndex: number; totalRV: number, msRating: string }[] = [];
        for (let i = 0; i < core.totalRV.length; i++) {
            for (let j = 0; j < core.totalRV[i].length; j++) {
                indexedData.push({
                    companionIndex: i,
                    buildIndex: j,
                    totalRV: core.totalRV[i][j],
                    msRating: core.msRating[i][j]
                });
            }
        }
        indexedData.sort((a, b) => {
            if (ratingOrder[a.msRating] !== ratingOrder[b.msRating]) {
                return ratingOrder[b.msRating] - ratingOrder[a.msRating];
            }
            return b.totalRV - a.totalRV;
        });
        const sorted = indexedData.map(item => ({
            cIndex: item.companionIndex,
            bIndex: item.buildIndex
        }));
        return sorted;
    }

    const protocoreResult = (core) => {
        return (
            <div className="result-div">
                <div className="result-item">
                    <div className="result-list-header">
                        <p className="flex-list-70">Relevance</p>
                        <p className="flex-list-15">Main Stat</p>
                        <p className="flex-list-15">Substat Score</p>
                    </div>
                    {sortedRV.map(({cIndex, bIndex}) => {
                        const percentage = Math.min((core.totalRV[cIndex][bIndex] / ((4 + core.level / 3) * 100)) * 100, 100);
                        const scalingBonus = `${companion[cIndex].scaling} Bonus`;
                        const coreDisplay = { core: core, companion: companion[cIndex].companion, build: build[bIndex], sortedTotalRV: sortedRV };
                        const [, comment] = assessMainstat(core.mainstat, companion[cIndex], build[bIndex]);
                        const scalingComment = core.substat1.attribute === scalingBonus || core.substat2.attribute === scalingBonus
                                                || core.substat3.attribute === scalingBonus || core.substat4.attribute === scalingBonus
                                                ? "as this protocore has companion scaling as one of the substats, prioritise it over similar-quality protocores that lack this substat."
                                                : "as this protocore does not have companion scaling as one of the substats, it is not recommended to prioritise this protocore."
                        return (
                            <div>
                                <div className={openAnalysis.cIndex === cIndex && openAnalysis.bIndex === bIndex ? "result-list-selected" : "result-list"} onClick={() => handleOpenAnalysis(cIndex, bIndex)}>
                                    <div className="combination-box list-box flex-list-70">
                                        <p className={`tag-box ${companion[cIndex].character}-bg-color ${companion[cIndex].character}-color`}>{companion[cIndex].companion}</p>
                                        <p className="tag-box build-box">{build[bIndex]}</p>
                                    </div>
                                    <div className={`mainstat-box list-box flex-list-15 ${core.msRating[cIndex][bIndex] === "S" || core.msRating[cIndex][bIndex] === "A" ? "good-mainstat-highlight" : ""}`}>
                                        <p>{core.msRating[cIndex][bIndex] === "S" ? "Good" : core.msRating[cIndex][bIndex] === "A" ? "--" : "Bad"}</p>
                                    </div>
                                    <div className={`substat-preview-box list-box flex-list-15 ${core.rvRating[cIndex][bIndex]}-core-bg-border`}>
                                        <p>{core.totalRV[cIndex][bIndex]}%</p>
                                    </div>
                                </div>
                                { openAnalysis.cIndex === cIndex && openAnalysis.bIndex === bIndex ?
                                    <div>
                                        <div className="analysis-div">
                                            { displayProtocore(coreDisplay, "current-core", false, 0, cIndex, bIndex) }
                                            <div className="core-analysis">
                                                <div className="overall-analysis">
                                                    <div className="companion-substat analysis-box">
                                                        <label>Has Companion Scaling as Substat</label>
                                                        <p>{core.substat1.attribute === scalingBonus || core.substat2.attribute === scalingBonus
                                                            || core.substat3.attribute === scalingBonus || core.substat4.attribute === scalingBonus
                                                            ? scalingBonus : "--"}</p>
                                                    </div>
                                                </div>
                                                <div className="substat-analysis analysis-box">
                                                    <div className="grid-container-substat">
                                                        <p className={`grid-item-substat ${core.substat1.ssRating[cIndex][bIndex]}-opacity`}>{core.substat1.attribute}</p>
                                                        <div className={`grid-item-substat substat-count ${core.substat1.ssRating[cIndex][bIndex]}-opacity`}>{Array.from({ length: core.substat1.rcount }, () => <div className="roll-count"></div>)}</div>
                                                        <p className={`grid-item-substat ${core.substat1.ssRating[cIndex][bIndex]}-opacity`}>{Math.round(core.substat1.rv[cIndex][bIndex])}%</p>
                                                        <p className={`grid-item-substat ${core.substat2.ssRating[cIndex][bIndex]}-opacity`}>{core.substat2.attribute}</p>
                                                        <div className={`grid-item-substat substat-count ${core.substat2.ssRating[cIndex][bIndex]}-opacity`}>{Array.from({ length: core.substat2.rcount }, () => <div className="roll-count"></div>)}</div>
                                                        <p className={`grid-item-substat ${core.substat2.ssRating[cIndex][bIndex]}-opacity`}>{Math.round(core.substat2.rv[cIndex][bIndex])}%</p>
                                                        { core.substat3.attribute !== "None" && <>
                                                            <p className={`grid-item-substat ${core.substat3.ssRating[cIndex][bIndex]}-opacity`}>{core.substat3.attribute}</p>
                                                            <div className={`grid-item-substat substat-count ${core.substat3.ssRating[cIndex][bIndex]}-opacity`}>{Array.from({ length: core.substat3.rcount }, () => <div className="roll-count"></div>)}</div>
                                                            <p className={`grid-item-substat ${core.substat3.ssRating[cIndex][bIndex]}-opacity`}>{Math.round(core.substat3.rv[cIndex][bIndex])}%</p>
                                                        </> }
                                                        { core.substat4.attribute !== "None" && <>
                                                            <p className={`grid-item-substat ${core.substat4.ssRating[cIndex][bIndex]}-opacity`}>{core.substat4.attribute}</p>
                                                            <div className={`grid-item-substat substat-count ${core.substat4.ssRating[cIndex][bIndex]}-opacity`}>{Array.from({ length: core.substat4.rcount }, () => <div className="roll-count"></div>)}</div>
                                                            <p className={`grid-item-substat ${core.substat4.ssRating[cIndex][bIndex]}-opacity`}>{Math.round(core.substat4.rv[cIndex][bIndex])}%</p>
                                                        </> }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="value-div progress-div">
                                            <div className={`progress-wrapper analysis-box ${core.rvRating[cIndex][bIndex]}-core-bg-border`}>
                                                <div className="progress-header">
                                                    <label>Substat Score</label>
                                                    <p className="progress-label">Max: {(4 + core.level / 3) * 100}%</p>
                                                </div>
                                                <div className="progress-padding">
                                                    <div className="progress-container">
                                                        <div className="progress-bar" style={{ width: `${percentage}%` }}></div>
                                                    </div>
                                                    <div className="progress-info">
                                                        <div
                                                            className="progress-percentage" 
                                                            style={{ left: `${percentage}%`, transform: "translateX(-50%)" }}
                                                        >
                                                            {core.totalRV[cIndex][bIndex]}%
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="value-div comment-div">
                                            <div className="analysis-box comment-analysis">
                                                <label>Recommendation</label>
                                                { enabledComment ?
                                                    <p>{ 
                                                        core.msRating[cIndex][bIndex] === "B" ? `This protocore has a ${comment}.`
                                                        : core.msRating[cIndex][bIndex] === "A" && core.rvRating[cIndex][bIndex] === "S" ? `Very good protocore ${core.level < 15 ? `to level. Additionally, ${scalingComment}` : ""}`
                                                        : core.msRating[cIndex][bIndex] === "A" && core.rvRating[cIndex][bIndex] === "A" ? `Good protocore ${core.level < 15 ? `to level. Additionally, ${scalingComment}` : ""}`
                                                        : core.msRating[cIndex][bIndex] === "A" && core.rvRating[cIndex][bIndex] === "B" ? `${core.level < 15 ? `Only level this protocore if really necessary. If levelling this, ${scalingComment}` : "Not a very good protocore."}`
                                                        : core.msRating[cIndex][bIndex] === "A" && core.rvRating[cIndex][bIndex] === "C" ? `Bad protocore${core.level < 15 ? ", do not level this piece" : ""}.`
                                                        : core.msRating[cIndex][bIndex] === "S" && core.rvRating[cIndex][bIndex] === "S" ? ((companion[cIndex].companion === "Farspace Colonel" || companion[cIndex].companion === "Lemurian Sea God") && core.mainstat === "DEF Bonus" && core.type === "") 
                                                            ? `${comment} The substats are very good. ${core.level < 15 ? `Highly recommended to level this if it is a Beta (cube) protocore, otherwise, not recommended. Additionally, ${scalingComment}` : ""}` 
                                                            : `This protocore has a ${comment} and the substats are very good. ${core.level < 15 ? `Highly recommended to level this protocore. Additionally, ${scalingComment}` : ""}`
                                                        : core.msRating[cIndex][bIndex] === "S" && core.rvRating[cIndex][bIndex] === "A" ? ((companion[cIndex].companion === "Farspace Colonel" || companion[cIndex].companion === "Lemurian Sea God") && core.mainstat === "DEF Bonus" && core.type === "") 
                                                            ? `${comment} The substats are good. ${core.level < 15 ? `It is worth leveling if it is a Beta (cube) protocore, otherwise, not recommended. Additionally, ${scalingComment}` : ""}` 
                                                            : `This protocore has a ${comment} and the substats are good. ${core.level < 15 ? `It is worth leveling. Additionally, ${scalingComment}` : ""}`
                                                        : core.msRating[cIndex][bIndex] === "S" && core.rvRating[cIndex][bIndex] === "B" ? ((companion[cIndex].companion === "Farspace Colonel" || companion[cIndex].companion === "Lemurian Sea God") && core.mainstat === "DEF Bonus" && core.type === "") 
                                                            ? `${comment} The substats are not very good. ${core.level < 15 ? `Level this protocore only if really necessary and only if this is a Beta (cube) protocore, otherwise, not recommended. If levelling this, ${scalingComment}` : ""}` 
                                                            : `This protocore has a ${comment} but the substats are not very good. ${core.level < 15 ? `Level this protocore only if really necessary. If levelling this, ${scalingComment}` : ""}`
                                                        : core.msRating[cIndex][bIndex] === "S" && core.rvRating[cIndex][bIndex] === "C" ? ((companion[cIndex].companion === "Farspace Colonel" || companion[cIndex].companion === "Lemurian Sea God") && core.mainstat === "DEF Bonus" && core.type === "") 
                                                            ? `${comment} The substats are very bad. ${core.level < 15 ? "Not recommended to level this protocore at all." : ""}` 
                                                            : `This protocore has a ${comment} but the substats are very bad. ${core.level < 15 ? "Not recommended to level this protocore at all." : ""}`
                                                        : "-" }
                                                    </p>
                                                    : <p>[ Recommendation Disabled ]</p>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    : ""
                                }
                            </div>
                        
                        );
                    })}
                </div>
            </div>
        );
    }

    const retryRating = (index) => {
        setCompanion(coreList[index].companion)
        setBuild(coreList[index].build);
        setCore(coreList[index].core);
        setError("");
        setComplete("history");
        setOpenAnalysis({ cIndex: coreList[index].sortedTotalRV[0].cIndex, bIndex: coreList[index].sortedTotalRV[0].bIndex });
        setSortedRV(coreList[index].sortedTotalRV);
    }

    const deleteCore = (index) => {
        const coreSlot = coreList[index].core.type === "Alpha" || coreList[index].core.type === "Gamma" ? "core1"
            : coreList[index].core.type === "Beta" || coreList[index].core.type === "Delta" ? "core2" : "";
        const cardSlot = Object.keys(team).find(key => {
            const value = team[key];
            return typeof value === "object" && value.memory === coreList[index].core.equip && value.memory !== "";
        }) || "";
        if (coreSlot && cardSlot) {
            setTeam({...team, [cardSlot]: { ...team[cardSlot], [coreSlot]: { hp: 0, atk: 0, def: 0, critrate: 0, critdmg: 0, dbw: 0, eeb: 0, orb: 0, os: 0 } }});
        }
        setCoreList((prevList) => prevList.filter((_, i) => i !== index));
        setTagCIndex((prevList) => prevList.filter((_, i) => i !== index));
        setTagBIndex((prevList) => prevList.filter((_, i) => i !== index));
    }
 
    const displayProtocore = (item, styling, isDetailed, index, companionIndex, buildIndex) => {
        const cIndex = !isDetailed ? companionIndex : (tagCIndex[index] === -1) ? item.sortedTotalRV[0].cIndex : tagCIndex[index];
        const bIndex = !isDetailed ? buildIndex : (tagBIndex[index] === -1) ? item.sortedTotalRV[0].bIndex : tagBIndex[index];
        const changeCIndex = (newCIndex) => {
            setTagCIndex((prev) => {
                const updatedIndexes = [...prev];
                updatedIndexes[index] = newCIndex;
                return updatedIndexes;
            });
        };
        const changeBIndex = (newBIndex) => {
            setTagBIndex((prev) => {
                const updatedIndexes = [...prev];
                updatedIndexes[index] = newBIndex;
                return updatedIndexes;
            });
        };
        const companionInfo = !isDetailed ? companionList.find(
            (option) => option.companion === item.companion
        ) : item.companion[cIndex];
        const scalingBonus = `${companionInfo.scaling} Bonus`;
        return (
            <div className={`${styling} display-core`}>
                <div className="core-info">
                    <div className="core-header">
                        <div className="core-type">
                            <p className={`${item.core.stellactrum}-color stellactrum-circle`}>{`${item.core.type === "Alpha" ? "\u2666\uFE0E" : item.core.type === "Beta" ? "\u25A0\uFE0E" : item.core.type === "Gamma" ? "\u2738\uFE0E" : item.core.type === "Delta" ? "\u25BC\uFE0E" : "\u2B24\uFE0E"}`}</p>
                            <p className="type-name">{item.core.stellactrum} Protocore {item.core.type === "Alpha" ? "- α" : item.core.type === "Beta" ? "- β" : item.core.type === "Gamma" ? "- γ" : item.core.type === "Delta" ? "- δ" : ""}</p>
                        </div>
                        <div className="level-div">
                            <p className="core-level">+{item.core.level}</p>
                        </div>
                    </div>
                    { isDetailed &&
                        <div className="core-tags">
                            { item.companion.map((option, c) => (
                                <div key={c}>
                                    <p className={`${option.character}-bg-color ${option.character}-color tag-style`} onClick={() => changeCIndex(c)}>{cIndex === c ? "\u2713 " : ""}{option.companion}</p>
                                </div>
                            ))}
                            { item.build.map((option, b) => (
                                <div key={b}>
                                    <p className="tag-style" onClick={() => changeBIndex(b)}>{bIndex === b ? "\u2713 " : ""}{option}</p>
                                </div>
                            ))}
                        </div>
                    }
                    <div className="core-mainstat">
                        <p className="stat-attribute">{item.core.mainstat}</p>
                        <p className="stat-value"> 
                            +{(() => {
                                const mainstat = mainstatList.find((option) => option.attribute === item.core.mainstat);
                                return mainstat ? parseFloat(((mainstat.increment * item.core.level) + mainstat.initial).toFixed(1)) : "";
                            })()}
                            {item.core.mainstat === "HP" || item.core.mainstat === "ATK" ? "" : "%"}
                        </p>
                    </div>
                    <div className={`core-substat ${item.core.substat1.attribute === scalingBonus ? "scaling-substat" : item.core.substat1.attribute !== scalingBonus && item.core.substat1.ssRating[cIndex][bIndex] === "S" ? "good-substat" : ""}`}>
                        <p className="stat-attribute">{item.core.substat1.attribute}</p>
                        <p className="stat-value">
                            +{item.core.substat1.value}
                            {item.core.substat1.attribute === "HP" || item.core.substat1.attribute === "ATK" || item.core.substat1.attribute === "DEF" ? "" : "%"}
                        </p>
                    </div>
                    <div className={`core-substat ${item.core.substat2.attribute === scalingBonus ? "scaling-substat" : item.core.substat2.attribute !== scalingBonus && item.core.substat2.ssRating[cIndex][bIndex] === "S" ? "good-substat" : ""}`}>
                        <p className="stat-attribute">{item.core.substat2.attribute}</p>
                        <p className="stat-value">
                            +{item.core.substat2.value}
                            {item.core.substat2.attribute === "HP" || item.core.substat2.attribute === "ATK" || item.core.substat2.attribute === "DEF" ? "" : "%"}
                        </p>
                    </div>
                    {
                        item.core.substat3.attribute !== "None" &&
                        <div className={`core-substat ${item.core.substat3.attribute === scalingBonus ? "scaling-substat" : item.core.substat3.attribute !== scalingBonus && item.core.substat3.ssRating[cIndex][bIndex] === "S" ? "good-substat" : ""}`}>
                            <p className="stat-attribute">{item.core.substat3.attribute}</p>
                            <p className="stat-value">
                                +{item.core.substat3.value}
                                {item.core.substat3.attribute === "HP" || item.core.substat3.attribute === "ATK" || item.core.substat3.attribute === "DEF" ? "" : "%"}
                            </p>
                        </div>
                    }
                    {
                        item.core.substat4.attribute !== "None" &&
                        <div className={`core-substat ${item.core.substat4.attribute === scalingBonus ? "scaling-substat" : item.core.substat4.attribute !== scalingBonus && item.core.substat4.ssRating[cIndex][bIndex] === "S" ? "good-substat" : ""}`}>
                            <p className="stat-attribute">{item.core.substat4.attribute}</p>
                            <p className="stat-value">
                                +{item.core.substat4.value}
                                {item.core.substat4.attribute === "HP" || item.core.substat4.attribute === "ATK" || item.core.substat4.attribute === "DEF" ? "" : "%"}
                            </p>
                        </div>
                    }
                </div>
                { isDetailed &&
                    <div>
                        <div className="core-display-rating">
                            <p className={`${item.core.msRating[cIndex][bIndex] === "S" || item.core.msRating[cIndex][bIndex] === "A" ? "good-ms-bg-color" : "bad-ms-bg-color"} core-rating`}>Main stat: {item.core.msRating[cIndex][bIndex] === "S" ? "Good" : item.core.msRating[cIndex][bIndex] === "A" ? "--" : "Bad"}</p>
                            <p className={`${item.core.rvRating[cIndex][bIndex]}-core-bg-border core-rating`}>Substat: {item.core.totalRV[cIndex][bIndex]}%</p>
                        </div>
                        <div className="core-display-tools">
                            <button className="tool-button" onClick={() => retryRating(index)}>&#8635; Reuse Core Data</button>
                            <button className="tool-button" onClick={() => deleteCore(index)}>&#215; Delete</button>
                        </div>
                    </div>
                }
            </div>
        );
    }

    const extractTextFromImage = async (imageFile) => {
        const { data: { text } } = await Tesseract.recognize(imageFile, 'eng');
        return text
        .split('\n')
        .map(line => line.trim())
        .filter(line => line !== '')
        .join('\n');
    };

    const fixBrokenWords = (text) => {
        const lines = text
            .split('\n')
            .map(line => line.trim())
            .filter(line => line !== '');
        const fixedLines: string[] = [];
        let state: 'waitingForItem' | 'skippingGibberish' | 'collecting' = 'waitingForItem';
        let mainstatAttr = mainstatList.map(item => {
            const key = item.attribute.toLowerCase();
            if (key === 'dmg boost to weakened') return 'dmg boost to';
            if (key === 'expedited energy boost') return 'expedited energy';
            return key;
        });
        mainstatAttr.push('oaths strength');
        mainstatAttr.sort((a, b) => b.length - a.length);

        for (let i = 0; i < lines.length; i++) {
            const current = lines[i].trim();
            const next = lines[i + 1]?.trim() || '';
            if (state === 'waitingForItem') {
                if (/Protocore/i.test(current)) {
                    fixedLines.push(current);
                    state = 'skippingGibberish';
                }
            }
            if (state === 'skippingGibberish') {
                const found = mainstatAttr.some(k => current.toLowerCase().includes(k));
                if (found) {
                    state = 'collecting';
                }
            }
            if (state === 'collecting') {
                if (current.includes('DMG Boost to') && next.includes('Weakened')) {
                    const index = next.indexOf('Weakened');
                    const stitchedLine = 'DMG Boost to Weakened' + next.slice(index + 'Weakened'.length);
                    fixedLines.push(stitchedLine.trim());
                    i++;
                } else if (current.includes('Expedited Energy')) {
                    const value = next.trim().split(/\s+/).pop() || '';
                    const stitchedLine = 'Expedited Energy Boost' + value;
                    fixedLines.push(stitchedLine.trim());
                    i++;
                } else if (current.includes('Oaths Strength')) {
                    const value = current.trim().split(/\s+/).pop() || '';
                    const stitchedLine = "Oath's Strength" + value;
                    fixedLines.push(stitchedLine.trim());
                } else {
                    fixedLines.push(current);
                }
            }
        }
        return fixedLines.join('\n');
    };

    const parseStellactrumText = (text) => {
        const stellactrumMatch = text.match(/(\w+)\s+Protocore/i);
        if (stellactrumMatch) {
            const color = stellactrumMatch[1];
            if (stellactrumList.includes(color)) {
                return stellactrumList.find(item => item.toLowerCase() === color.toLowerCase());;
            }
        }
        return "";
    };

    const parseMainStatText = (text) => {
        const lines = text.split('\n');
        if (lines.length >= 2) {
            const secondLine = lines[1];
            const mainstatAttr = mainstatList.map(item => item.attribute);
            mainstatAttr.sort((a, b) => b.length - a.length);
            const pattern = new RegExp(`\\b(${mainstatAttr.join('|')})\\b`, 'i');
            const mainstatMatch = secondLine.match(pattern);
            return mainstatMatch ? mainstatAttr.find(item => item.toLowerCase() === mainstatMatch[1].toLowerCase()) : "";
        }
        return "";
    }

    const parseSubstatText = (text, substat) => {
        const lines = text.split('\n');
        const lineNumber = substat === 1 ? 2 : substat === 2 ? 3 : substat === 3 ? 4 : 5;
        if (lines.length >= lineNumber + 1) {
            const substatLine = lines[lineNumber];
            const substatAttr = substatList.map(item => item.attribute);
            substatAttr.sort((a, b) => b.length - a.length);
            const pattern = new RegExp(`\\b(${substatAttr.join('|')})\\b`, 'i');
            const substatMatch = substatLine.match(pattern);
            const valueMatch = substatLine.match(/\+\d+(\.\d+)?/);
            if (substatMatch && valueMatch) {
                const attribute = substatAttr.find(item => item.toLowerCase() === substatMatch[1].toLowerCase());
                const value = parseFloat(valueMatch[0].replace('+', ''));
                return [attribute, value];
            } else if (substatMatch && !valueMatch) {
                const attribute = substatAttr.find(item => item.toLowerCase() === substatMatch[1].toLowerCase());
                return [attribute, 0];
            } else if (!substatMatch && valueMatch) {
                const value = parseFloat(valueMatch[0].replace('+', ''));
                return ["", value];
            } else {
                return ["", 0];
            }
        }
        else if (lines.length < lineNumber + 1) {
            return ["None", 0];
        }
        return ["", 0];
    } 

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            imageToText(file);
        } else {
            setIsScanning(false);
        }
        event.target.value = null;
    };

    const imageToText = async (file) => {
        setIsScanning(true);
        const extractedText = await extractTextFromImage(file);
        setIsScanning(false);
        const text = fixBrokenWords(extractedText);
        const parsedStellactrum = parseStellactrumText(text) as string;
        const parsedMainStat = parseMainStatText(text) as string;
        const [parsedSubstat1, parsedValue1] = parseSubstatText(text, 1) as [string, number];
        const [parsedSubstat2, parsedValue2] = parseSubstatText(text, 2) as [string, number];
        const [parsedSubstat3, parsedValue3] = parseSubstatText(text, 3) as [string, number];
        const [parsedSubstat4, parsedValue4] = parseSubstatText(text, 4) as [string, number];
        setCore({...core, stellactrum: parsedStellactrum, level: 0, mainstat: parsedMainStat,
            substat1: {...core.substat1, attribute: parsedSubstat1, value: parsedValue1},
            substat2: {...core.substat2, attribute: parsedSubstat2, value: parsedValue2},
            substat3: {...core.substat3, attribute: parsedSubstat3, value: parsedValue3},
            substat4: {...core.substat4, attribute: parsedSubstat4, value: parsedValue4}
        });
        reverseCompletion();
    }

    const uploadScreenshot = () => {
        imageInputRef.current.click();
    };

    const handleOpenInstruction = () => {
        setOpenInstruction(!openInstruction);
    }

    const exportHistory = (option) => {
        const fileName = `protocore-rater-data-${Date.now()}.json`
        const exportPayload = option === 1 ? { coreList, tagCIndex, tagBIndex }
            : { coreList, tagCIndex, tagBIndex, team };
        const json = JSON.stringify(exportPayload, null, 2);
        const blob = new Blob([json], { type: "application/json" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (event) => {
            try {
            const importedData = JSON.parse(event.target.result);
            setCoreList(importedData.coreList || []);
            setTagCIndex(importedData.tagCIndex || []);
            setTagBIndex(importedData.tagBIndex || []);
            setTeam(importedData.team || defaultTeams);
            } catch (err) {
            console.error("Invalid JSON structure", err);
            } finally {
                e.target.value = "";
            }
        };
        reader.readAsText(file);
    };

    const importHistory = () => {
        fileInputRef.current.click();
    };

    useEffect(() => {
        const sorted = getSortedTotalRV(core);
        if (complete === "rater") {
            setCoreList((prevList) => {
                if (prevList.length >= 60) {
                    return [{ core: core, companion: companion, build: build, sortedTotalRV: sorted }, ...prevList.slice(0, prevList.length - 1)];
                } else {
                    return [{ core: core, companion: companion, build: build, sortedTotalRV: sorted }, ...prevList];
                }
            });
            setTagCIndex((prevList) => {
                if (prevList.length >= 60) {
                    return [-1, ...prevList.slice(0, prevList.length - 1)];
                } else {
                    return [-1, ...prevList];
                }
            });
            setTagBIndex((prevList) => {
                if (prevList.length >= 60) {
                    return [-1, ...prevList.slice(0, prevList.length - 1)];
                } else {
                    return [-1, ...prevList];
                }
            });
            setSortedRV(sorted);
        }
        if (sorted) {
            setReadyForDisplay(true);
        }
    }, [complete]);

    useEffect(() => {
        if (sortedRV.length > 0) {
            setOpenAnalysis({cIndex: sortedRV[0].cIndex, bIndex: sortedRV[0].bIndex});
        }
    }, [sortedRV]);

    useEffect(() => {
        const handlePasteImage = (event) => {
            const activeEl = document.activeElement;
            const isInputField = 
            activeEl.tagName === 'INPUT' || 
            activeEl.tagName === 'TEXTAREA' || 
            activeEl.isContentEditable;
            if (isInputField) return;
            const image = event.clipboardData?.items;
            if (!image) return;
            for (let i = 0; i < image.length; i++) {
                if (image[i].type.indexOf('image') !== -1) {
                    const file = image[i].getAsFile();
                    if (file) {
                        event.preventDefault();
                        imageToText(file);
                    }
                    else{
                        setIsScanning(false);
                    }
                    break;
                }
            }
        };
        document.addEventListener('paste', handlePasteImage);
        return () => {
            document.removeEventListener('paste', handlePasteImage);
        };
    }, []);

	return (
		<div>
            <div className="page">
                <div className="general-info">
                    <div className="rater-form">
                        <p className="form-section-label">Protocore Details</p>
                        <div className="form-row">
                            <div className="select-width-30">
                                <p className="memory-label">Stellactrum Color</p>
                                <button ref={(el) => (buttonRefs.current["stellactrumDD"] = el)} className={`form-select select-width-100 dropdown ${core.stellactrum === "" ? "default-bg-color" : `${core.stellactrum}-bg-color`}`}
                                    onClick={() => toggleDropdown('stellactrumDD')}>
                                    <p className="dropdown-text">{core.stellactrum || "Stellactrum"}</p>
                                    {openDropdowns['stellactrumDD'] ? <p className="dropdown-arrow">&#9652;</p> : <p className="dropdown-arrow">&#9662;</p>}
                                </button>
                                {openDropdowns['stellactrumDD'] && (
                                    <div ref={(el) => (dropdownRefs.current["stellactrumDD"] = el)} className="dropdown-list-left dropdown-width-30">
                                        {stellactrumList.map((option, index) => (
                                            <div key={index} className={`dropdown-item default-bg-color-hover stellactrum-option`}
                                            onClick={() => selectStellactrum(option)}>
                                                <p className={`${option}-color circle-option`}>&#11044;</p>
                                                <p>{option}</p>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <div className="select-width-70 form-row-buffer">
                                <p className="memory-label">Type (Optional)</p>
                                <button ref={(el) => (buttonRefs.current["typeDD"] = el)} className="form-select select-width-100 dropdown white-bg-color"
                                    onClick={() => toggleDropdown('typeDD')}>
                                    <p className="dropdown-text">{ core.type || "Type" }</p>
                                    {openDropdowns['typeDD'] ? <p className="dropdown-arrow">&#9652;</p> : <p className="dropdown-arrow">&#9662;</p>}
                                </button>
                                {openDropdowns['typeDD'] && (
                                    <div ref={(el) => (dropdownRefs.current["typeDD"] = el)} className="dropdown-list-right dropdown-width-70">
                                        <div className="dropdown-item default-bg-color-hover"
                                            onClick={() => selectCoreType("")}>
                                                No selection
                                        </div>
                                        {coreTypeList.map((option, index) => (
                                            <div key={index} className="dropdown-item default-bg-color-hover stellactrum-option"
                                            onClick={() => selectCoreType(option)}>
                                                <p className={`${core.stellactrum !== "" ? `${core.stellactrum}-color` : "default-text-color"} circle-option`}>
                                                    {`${option === "Alpha" ? "\u2666\uFE0E" : option === "Beta" ? "\u25A0\uFE0E" : option === "Gamma" ? "\u2738\uFE0E" : option === "Delta" ? "\u25BC\uFE0E" : ""}`}
                                                </p>
                                                <p>{option}</p>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="select-width-30">
                                <p className="memory-label">Level</p>
                                <button ref={(el) => (buttonRefs.current["levelDD"] = el)} className="form-select select-width-100 dropdown white-bg-color"
                                    onClick={() => toggleDropdown('levelDD')}>
                                    <p className="dropdown-text">{core.level}</p>
                                    {openDropdowns['levelDD'] ? <p className="dropdown-arrow">&#9652;</p> : <p className="dropdown-arrow">&#9662;</p>}
                                </button>
                                {openDropdowns['levelDD'] && (
                                    <div ref={(el) => (dropdownRefs.current["levelDD"] = el)} className="dropdown-list-left dropdown-width-30">
                                        {levelList.map((option, index) => (
                                            <div key={index} className="dropdown-item default-bg-color-hover"
                                            onClick={() => selectCoreLevel(option)}>
                                                {option}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <div className="select-width-70 form-row-buffer">
                                <p className="memory-label">Main Stat</p>
                                <button ref={(el) => (buttonRefs.current["mainstatDD"] = el)} className="form-select select-width-100 dropdown white-bg-color"
                                    onClick={() => toggleDropdown('mainstatDD')}>
                                    <p className="dropdown-text">{core.mainstat || "Main Stat"}</p>
                                    {openDropdowns['mainstatDD'] ? <p className="dropdown-arrow">&#9652;</p> : <p className="dropdown-arrow">&#9662;</p>}
                                </button>
                                {openDropdowns['mainstatDD'] && (
                                    <div ref={(el) => (dropdownRefs.current["mainstatDD"] = el)} className="dropdown-list-right dropdown-width-70">
                                        {mainstatList
                                            .filter(option => {
                                                const filter = core.type === "Alpha" ? option.attribute === "HP" : 
                                                    core.type === "Gamma" ? option.attribute === "ATK" :
                                                    core.type === "Beta" ? (option.attribute !== "HP" && option.attribute !== "ATK" && option.attribute !== "Crit Rate" && option.attribute !== "Crit DMG" && option.attribute !== "DMG Boost to Weakened") :
                                                    core.type === "Delta" ? (option.attribute !== "HP" && option.attribute !== "ATK" && option.attribute !== "Expedited Energy Boost" && option.attribute !== "Oath Recovery Boost" && option.attribute !== "Oath's Strength") :
                                                    true;
                                                return filter;
                                            }).map((option, index) => (
                                                <div key={index} className="dropdown-item default-bg-color-hover"
                                                onClick={() => selectMainstat(option.attribute)}>
                                                    {option.attribute}
                                                </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div>
                            {substatDropdown(core.substat1, "substat1DD", "Substat 1", false, selectSubstat1, selectSubstat1Value)}
                            {substatDropdown(core.substat2, "substat2DD", "Substat 2", false, selectSubstat2, selectSubstat2Value)}
                            {substatDropdown(core.substat3, "substat3DD", "Substat 3", true, selectSubstat3, selectSubstat3Value)}
                            {substatDropdown(core.substat4, "substat4DD", "Substat 4", true, selectSubstat4, selectSubstat4Value)}
                        </div>
                        <div className="screenshot-uploader">
                            { isScanning && <div className="loader"></div> }
                            <button className={`${core.stellactrum !== "" ? `${core.stellactrum}-light-bg-color` : "default-bg-color"} ${isScanning ? "disabled-form" : ""} upload-button`}
                                onClick={uploadScreenshot}>Upload Screenshot</button>
                            <input
                                type="file"
                                accept="image/*"
                                ref={imageInputRef}
                                onChange={handleImageChange}
                                style={{ display: "none" }}
                            />
                            <div className="upload-instruction">
                                <button className={`${core.stellactrum !== "" ? `${core.stellactrum}-dark-color` : "default-color"} instruction-button`} onClick={() => handleOpenInstruction()}>
                                    <p className="instruction-label">How to use?</p>
                                    { openInstruction ? <p className="dropdown-arrow">&#9652;</p> : <p className="dropdown-arrow">&#9662;</p> }
                                </button>
                                { openInstruction &&
                                    <ol className="instruction-text">
                                        <li>Crop the screenshot so only the black rectangle with protocore details is shown.</li>
                                        <li>Upload the screenshot.</li>
                                        <li>Check if protocore details are correct after uploading and add any missing details manually.</li>
                                    </ol>
                                }
                            </div>
                        </div>
                        <div className="screenshot-paste">
                            <p>OR <kbd>Ctrl</kbd> + <kbd>V</kbd> anywhere to paste screenshot</p>
                        </div>
                        <p className="form-section-label">Companion Selection</p>
                        <div className="companion-selection-form">
                            <div className="checkbox-wrapper">
                                <div
                                    className={`${allCompanionSelected ? "default-bg-color" : "white-bg-color"} checkbox`} 
                                    onClick={() => selectCompanion({ companion: "all", scaling: "", character: "" })}
                                ></div>
                                <div className="checkbox-label">All</div>
                            </div>
                            <div className="checkbox-wrapper">
                                <div 
                                    className={`${companion.some((selected) => selected.companion === "Standard") ? "default-bg-color" : "white-bg-color"} checkbox`} 
                                    onClick={() => selectCompanion(companionList.find(item => item.companion === "Standard"))}
                                ></div>
                                <div className="checkbox-label">Standard</div>
                            </div>
                            <div className="grid-container-checkbox">
                                {Object.entries(groupByCharacter(companionList.filter((option) => option.companion !== "Standard"))).map(([character, companions]) => (
                                    <React.Fragment key={character}>
                                        {companions.map((option, index) => {
                                            const isSelected = companion.some((selected) => selected.companion === option.companion);
                                            return (
                                                <div key={option.companion} className={`checkbox-wrapper ${(index === companions.length - 1 && index % 2 === 0) ? 'full-width' : ''}`}>
                                                    <div 
                                                        className={`${isSelected ? `${option.character}-bg-color` : "white-bg-color"} checkbox`} 
                                                        onClick={() => selectCompanion(option)}
                                                    ></div>
                                                    <div className="checkbox-label">{option.companion}</div>
                                                </div>
                                            );
                                        })}
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                        <p className="form-section-label">Build Selection</p>
                        <div className="build-container">
                            {buildList.map((option, index) => {
                                const isSelected = build.some((selected) => selected === option);
                                return (
                                    <div key={index} className="checkbox-wrapper build-flex">
                                        <div 
                                            className={`${isSelected ? (core.stellactrum !== "" ? `${core.stellactrum}-light-bg-color` : "default-bg-color") : "white-bg-color"} checkbox`}
                                            onClick={() => selectBuild(option)}
                                        ></div>
                                        <div className="checkbox-label">{option}</div>
                                    </div>
                                );
                            })}
                        </div>
                        { enabledStrictRating ? 
                            <button className="toggle-comment white-bg-color" onClick={selectEnabledStrictRating}>
                                <label className="toggle-comment-label">Strict Crit/DBW Builds Rating Enabled</label>
                                <div className={`toggle-comment-container toggle-comment-true ${core.stellactrum !== "" ? `${core.stellactrum}-bg-color` : "default-bg-color"}`}>
                                    <div className="toggle-button"></div>
                                </div>
                            </button>
                            : <button className="toggle-comment white-bg-color" onClick={selectEnabledStrictRating}>
                                <label className="toggle-comment-label">Strict Crit/DBW Builds Rating Disabled</label>
                                <div className="toggle-comment-container toggle-comment-false default-bg-color">
                                    <div className="toggle-button"></div>
                                </div>
                            </button>
                        }
                        { enabledFlatStat ? 
                            <button className="toggle-comment white-bg-color" onClick={selectEnabledFlatStat}>
                                <label className="toggle-comment-label">Flat Stat Importance Increased</label>
                                <div className={`toggle-comment-container toggle-comment-true ${core.stellactrum !== "" ? `${core.stellactrum}-bg-color` : "default-bg-color"}`}>
                                    <div className="toggle-button"></div>
                                </div>
                            </button>
                            : <button className="toggle-comment white-bg-color" onClick={selectEnabledFlatStat}>
                                <label className="toggle-comment-label">Flat Stat Importance Reduced</label>
                                <div className="toggle-comment-container toggle-comment-false default-bg-color">
                                    <div className="toggle-button"></div>
                                </div>
                            </button>
                        }
                        { enabledComment ? 
                            <button className="toggle-comment white-bg-color" onClick={selectEnabledComment}>
                                <label className="toggle-comment-label">Recommendation Enabled</label>
                                <div className={`toggle-comment-container toggle-comment-true ${core.stellactrum !== "" ? `${core.stellactrum}-bg-color` : "default-bg-color"}`}>
                                    <div className="toggle-button"></div>
                                </div>
                            </button>
                            : <button className="toggle-comment white-bg-color" onClick={selectEnabledComment}>
                                <label className="toggle-comment-label">Recommendation Disabled</label>
                                <div className="toggle-comment-container toggle-comment-false default-bg-color">
                                    <div className="toggle-button"></div>
                                </div>
                            </button>
                        }
                        <div className={(companion.length === 0 || build.length === 0 || core.mainstat === "" || core.stellactrum === "") ? "disabled-form" : ""}>
                            <button className={`${core.stellactrum !== "" ? `${core.stellactrum}-light-bg-color` : "default-bg-color"} calculate-button`} onClick={calculateTotalRV}>Rate Protocore</button>
                        </div>
                    </div>
                    <div className={`rater-result ${core.stellactrum !== "" ? `${core.stellactrum}-light-bg-color` : "default-bg-color" }`}>
                        { error !== ""
                        ? <div className="error">{error}</div> 
                        : ((readyForDisplay === true && complete === "rater")  || complete === "history") ? protocoreResult(core) :
                        <div>
                            <p className={`info-header ${core.stellactrum !== "" ? `${core.stellactrum}-light-bg-color ${core.stellactrum}-dark-color` : "default-bg-color default-color"}`}>PROTOCORE RATER</p>
                            <h1 className="info-body">Protocore Rater is a tool for comparing protocores and improving team builds, a guide for the game Love And Deepspace.</h1>
                            <p className="info-body">Enter protocore details and click '<b>Rate Protocore</b>'.</p>
                            <p className="info-body">This rater is only for rating SSR (gold) protocores. Lower rarity protocores are not worth leveling at all.</p>
                            <p className="info-body">For each three level upgrades, it is best to rate the protocore again as the rating may change.</p><br/>
                            <p className={`info-header ${core.stellactrum !== "" ? `${core.stellactrum}-light-bg-color ${core.stellactrum}-dark-color` : "default-bg-color default-color"}`}>Which build to choose?</p>
                            <p className="info-body"><b>Crit Build</b> is recommended when fighting without matching Stellactrum colors, fighting shielded enemies or enemies without protocore shields.</p>
                            <p className="info-body"><b>DMG to Weakened Build</b> is recommended when fighting with all matching Stellactrum colors as enemies will often be in weakened state.</p>
                            <p className="info-body"><b>Mixed Build</b> will rate stats for both Crit and DMG to Weakened Build equally.</p>
                            <p className="info-body"><b>Strict Rating Toggle</b> will rate strictly to the chosen build and will not consider stats for other builds when enabled. When disabled, rater will take into consideration DMG Boost to Weakened stats when rating Crit builds, and Crit stats when rating DMG Boost to Weakened builds.</p><br/>
                            <p className={`info-header ${core.stellactrum !== "" ? `${core.stellactrum}-light-bg-color ${core.stellactrum}-dark-color` : "default-bg-color default-color"}`}>Flat Stat Importance</p>
                            <p className="info-body">Recommended to turn this feature on when assessing a protocore for a memory with base ATK less than 600 OR base HP less than 12000 for HP scaling companion OR base DEF less than 300 for DEF scaling companion.</p>
                            <p className="info-body">Each memory base stat is shown on detailed stat screen. It is the black number before being added with orange number.</p><br/>
                            <p className={`info-header ${core.stellactrum !== "" ? `${core.stellactrum}-light-bg-color ${core.stellactrum}-dark-color` : "default-bg-color default-color"}`}>Import/Export Protocore List</p>
                            <p className="info-body">Export function will save your protocore data as .JSON file to your device. Please <b>do not modify the file</b> or it will become unusable when importing.</p>
                            <p className="info-body">Import function will load your protocore list back into the rater. It will <b>overwrite any existing protocores</b> currently on the rater.</p>
                            <p className={`info-header valko`}>#KeepValkoAlive</p>
                            <p className={`info-header valko`}>#NoToValkoCancellation</p>
                            <p className={`info-header valko`}>#BringValkoBack</p>
                            <p className={`info-header valko`}>#JusticeforValko</p>
                            <p className={`info-header valko`}>#Valko</p>
                        </div>
                        }
                    </div>
                </div>
                <div className="export-import-menu">
                    <p className="form-section-label history-section-label">Protocore List</p>
                    <button className={`${core.stellactrum !== "" ? `${core.stellactrum}-light-bg-color` : "default-bg-color"} ${coreList.length < 1 ? "disabled-form" : ""} footer-button`}
                        onClick={() => exportHistory(1)}>Export Protocore List</button>
                    <button className={`${core.stellactrum !== "" ? `${core.stellactrum}-light-bg-color` : "default-bg-color"} ${coreList.length < 1 ? "disabled-form" : ""} footer-button`}
                        onClick={() => exportHistory(2)}>Export Protocore and Team List</button>
                    <button className={`${core.stellactrum !== "" ? `${core.stellactrum}-light-bg-color` : "default-bg-color"} footer-button`}
                        onClick={importHistory}>Import Protocore List</button>
                    <input
                        type="file"
                        accept="application/json"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                    />
                </div>
                <div className="past-record">
                    <div className="history-div">
                        { coreList.map((item, index) => (
                            <React.Fragment key={index}>{displayProtocore(item, "past-core", true, index, -1, -1)}</React.Fragment>
                        )) }
                    </div>
                </div>
                <div className="footer">
                    <button className={`${core.stellactrum !== "" ? `${core.stellactrum}-light-bg-color` : "default-bg-color"} footer-button`}
                        onClick={() => handleOpenLog()}>Change Log</button>
                    <button className={`${core.stellactrum !== "" ? `${core.stellactrum}-light-bg-color` : "default-bg-color"} footer-button`}
                        onClick={() => window.open("https://www.reddit.com/r/LoveAndDeepspace/comments/1slz1wf/protocore_rater_protocore_comparison_for_teams/", "_blank")}>Help & Feedback</button>
                </div>
                { openLog && 
                    <div className={`change-log ${core.stellactrum !== "" ? `${core.stellactrum}-light-bg-color` : "default-bg-color" }`}>
                        <ChangeLog/>
                    </div>
                }
            </div>
		</div>
	);
}

export default Rater;